import React from 'react';
import Fade from '@material-ui/core/Fade';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';
import { hasNoLimit } from '../../../util/insuranceDetails';

class Coinsurance extends Base {
  static isVisible = () => true;

  icon = '/images/insurance_tutorial/09_coinsurance.svg';

  render = () => {
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>Let's go splitsies</H2>

            <P>
              Once you’ve hit your deductible, you’ll pay a percentage for your care and your
              insurance will pay the rest. It’s called co-insurance.
            </P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default Coinsurance;
